export default __webpack_public_path__ + "static/media/work2.ccf3168d.svg";